<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" class="scrolled uncorupted" :merchandise="true"/>
    <McHeader class="scrolled"
      :title="bcTitle"
      :canGoBack="true" ref="mcHeader"/>
    <div class="loadingFull" v-if="loading"></div>
    <div class="notFound" v-else-if="!d">
      <h4>Produk tidak ditemukan</h4>
    </div>
    <div v-else>
      <div class="cnt">
        <div class="productCnt">
          <div class="productInfoImg">
            <div class="productImgCnt">
              <div class="imgThumb">
                <div class="thumbItem" v-for="(img, i) in images" :key="`img${i}`"
                  :style="{'background-image': `url(${img.media.imageSm})`}"
                  v-on:click="imgIdx = i"></div>
              </div>
              <div class="mainImg" v-if="images && images[imgIdx]"
                :style="{'background-image': `url(${images[imgIdx].media.imageLg})`}"></div>
              <div class="mainImg noImg" v-else></div>
            </div>
            <div class="productInfo">
              <div class="priceCnt priceMobile">
                <div class="priceDiscount" v-if="d.discount">
                  Rp {{d.discountedPrice.toLocaleString('id')}}
                </div>
                <div class="price">Rp {{d.sellPrice.toLocaleString('id')}}</div>
              </div>
              <h2>{{d.name}}</h2>

              <div class="addToCartCnt addToCartCntMobile">
                <div class="variantCnt" v-if="d.variants.length > 0">
                  <div v-for="(v, i) in d.variants" :key="`vm${i}`">
                    <template v-if="v.variants.length > 0">
                      <h4>{{v.name}}</h4>
                      <div class="variantSelector">
                        <div class="variantItem" :class="{color: v2.variantItem.color
                          && v2.variantItem.color !== '#EEEEEE', active: v.selected === i2,
                          outOfStock: Number(v2.inStock.model) < 1}"
                          :key="`v${i2}`"
                          v-on:click="selectVariant(i2, v2, i, v)" v-for="(v2, i2) in v.variants">
                          <div class="color" :style="{'background-color': v2.variantItem.color}"
                            v-if="v2.variantItem.color && v2.variantItem.color !== '#EEEEEE'"></div>
                            {{v2.variantItem.name}}</div>
                      </div>
                    </template>
                    <div class="variantError" v-if="v.error">
                      Mohon pilih variasi produk
                    </div>
                  </div>
                </div>
                <button class="reminder" v-if="1>2">Tidak menemukan ukuran?
                  <b>ingatkan jika tersedia</b></button>
                <div class="shareCnt">
                  <span>Bagikan</span>
                  <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`"
                    target="_blank" class="shareItem fb"></a>
                  <a :href="`https://twitter.com/intent/tweet?text=Beli Produk UNCORRUPTED ${d.name} di&amp;url=${shareUri}`"
                    target="_blank" class="shareItem tw"></a>
                  <a :href="`whatsapp://send?text=Beli Produk UNCORRUPTED ${d.name} di ${shareUri}`"
                    class="shareItem wa"></a>
                  <a :href="`mailto:?subject=${d.name}&amp;body=Beli Produk UNCORRUPTED
                    <a href='${shareUri}'>${d.name}</a>`" class="shareItem email"></a>
                </div>
              </div>

              <table class="infoTable">
                <tr class="infoItem" v-if="d.category">
                  <td class="infoL">Kategori</td>
                  <td>:</td>
                  <td class="infoR">{{d.category.name}}</td>
                </tr>
                <tr class="infoItem" v-if="d.edition">
                  <td class="infoL">Edisi</td>
                  <td>:</td>
                  <td class="infoR">{{d.edition.name}}</td>
                </tr>
                <tr class="infoItem" v-for="(info, i) in d.info" :key="`info${i}`">
                  <td class="infoL">{{info.label}}</td>
                  <td>:</td>
                  <td class="infoR">{{info.info}}</td>
                </tr>
              </table>
              <div class="deliveryInfo" v-if="d.warehouse">
                <h4>Informasi pengiriman</h4>
                <div class="warehouse">Dikirim dari <b>{{d.warehouse.cityName}}</b></div>
              </div>
              <div class="deliveryInfo loading" v-if="loadingCourier">
                <h4>Pengiriman tersedia</h4>
                <div class="courierItem" :class="`c${i}`" v-for="i in 3" :key="`cor${i}`">
                  <div class="courierLogo"></div>
                  <div class="courierInfo"></div>
                </div>
              </div>
              <div class="deliveryInfo" v-else-if="couriers.length > 0">
                <h4>Pengiriman tersedia</h4>
                <div class="courierItem" v-for="(c, i) in couriers" :key="`cor${i}`"
                  ><div class="courierLogo" :class="c.code"></div> {{c.name}}</div>
                <div class="courierItem more"
                  v-on:click="calcDelivery">Kalkulasi biaya pengiriman</div>
              </div>
              <div class="deliveryInfo promoInfo" v-if="promo.length > 0">
                <h4>Promo tersedia</h4>
                <div class="promoCnt">
                  <div class="promoItem" v-for="(item, i) in promo" :key="`promo${i}`">
                    <div class="promoItemIn">
                      <h5>{{item.name}}</h5>
                      <p>Potongan
                        <span v-if="item.discountType === 'fixed'">Rp
                        {{item.amount.toLocaleString('id')}}</span>
                        <span v-else>{{item.percentage}}%</span>
                      </p>
                      <div class="info" v-if="item.minPurchase > 0">Min. pembelian
                        <b>Rp {{item.minPurchase.toLocaleString('id')}}</b></div>
                      <div class="snk" v-on:click="snk(item)">Syarat dan Ketentuan</div>
                      <div class="noQuota" v-if="item.quotaLeft < 1">Promo habis</div>
                    </div>
                  </div>
                </div>
                <div class="promoInfoApplied">Promo akan otomatis dimasukan
                  ketika kamu checkout</div>
              </div>
            </div>
          </div>
          <div class="addToCartCnt" :style="{'margin-top': `${prdTop}px`}">
            <div class="variantCnt" v-if="d.variants.length > 0">
              <div v-for="(v, i) in d.variants" :key="`vm${i}`">
                <template v-if="v.variants.length > 0">
                  <h4>{{v.name}}</h4>
                  <div class="variantSelector">
                    <div class="variantItem" :class="{color: v2.variantItem.color
                      && v2.variantItem.color !== '#EEEEEE', active: v.selected === i2,
                      outOfStock: Number(v2.inStock.model) < 1}"
                      :key="`v${i2}`"
                      v-on:click="selectVariant(i2, v2, i, v)" v-for="(v2, i2) in v.variants">
                      <div class="color" :style="{'background-color': v2.variantItem.color}"
                        v-if="v2.variantItem.color && v2.variantItem.color !== '#EEEEEE'"></div>
                        {{v2.variantItem.name}}</div>
                  </div>
                </template>
                <div class="variantError" v-if="v.error">
                  Mohon pilih variasi produk
                </div>
              </div>
            </div>
            <div class="priceCnt" v-if="d.discount">
              <div class="priceDiscount">
                Rp {{d.sellPrice.toLocaleString('id')}}
              </div>
              <div class="price">Rp {{d.discountedPrice.toLocaleString('id')}}</div>
            </div>
            <div class="priceCnt" v-else>
              <div class="price">Rp {{d.sellPrice.toLocaleString('id')}}</div>
            </div>
            <div v-if="d.inStock < 1" class="outOfStock">Stock habis</div>
            <div v-else>
              <div class="inStock">Stock <b>{{d.inStock}}</b></div>
              <button class="btn primary addToCart" v-on:click="addToCart">Keranjang</button>
            </div>
            <button class="btn secondary wishlist" :class="{loved: d.inWishlist}"
              v-on:click="addToWishlist">Wishlist</button>
            <button class="reminder" v-if="1>2">Tidak menemukan ukuran?
              <b>ingatkan jika tersedia</b></button>
            <div class="shareCnt">
              <span>Bagikan</span>
              <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`"
                target="_blank" class="shareItem fb"></a>
              <a :href="`https://twitter.com/intent/tweet?text=Beli Produk UNCORRUPTED ${d.name} di&amp;url=${shareUri}`"
                target="_blank" class="shareItem tw"></a>
              <a :href="`whatsapp://send?text=Beli Produk UNCORRUPTED ${d.name} di ${shareUri}`"
                class="shareItem wa"></a>
              <a :href="`mailto:?subject=${d.name}&amp;body=Beli Produk UNCORRUPTED
                <a href='${shareUri}'>${d.name}</a>`" class="shareItem email"></a>
            </div>
          </div>
        </div>
      </div>

      <div class="addToCartBtnMobile">
        <div class="priceCnt">
          <div class="priceDiscount" v-if="d.discount">
            Rp {{d.discountedPrice.toLocaleString('id')}}
          </div>
          <div class="price">Rp {{d.sellPrice.toLocaleString('id')}}</div>
        </div>
        <div v-if="d.inStock < 1" class="outOfStock">Stock habis</div>
        <button class="btn primary addToCart" v-else v-on:click="addToCart">Keranjang</button>
      </div>

      <div class="tabDdCnt" :class="{open: ddOpen}">
        <div class="tabDd" v-on:click.stop="ddOpen = !ddOpen"
          v-if="tabActive === 999">
          Jam Operasional
        </div>
        <div class="tabDd" v-on:click.stop="ddOpen = !ddOpen" v-else>
          {{d.tabs[tabActive].title}}
        </div>
        <div class="tabHeader" v-on:click.stop="doNothing">
          <div class="cnt">
            <li v-for="(tab, i) in d.tabs" :key="`tab${i}`"
              v-on:click.stop="tabActive = i; ddOpen = false"
              :class="{active: tabActive === i}">
              {{tab.title}}
            </li>
            <li v-if="cm" v-on:click.stop="tabActive = 999; ddOpen = false"
              :class="{active: tabActive === 999}">
              Jam Operasional
            </li>
          </div>
        </div>
      </div>
      <div class="tabContent">
        <div class="cnt">
          <div class="articleContent" v-if="d.tabs && d.tabs[tabActive]"
            v-html="d.tabs[tabActive].model"></div>
          <div class="articleContent" v-else-if="tabActive === 999 && cm"
            v-html="cm.operationalHours"></div>
        </div>
      </div>
      <div ref="endProduct"></div>
      <div class="cnt">
        <div class="related">
          <div v-if="related.length > 0">
            <h4>Produk terkait</h4>
            <div class="relatedCnt merchandise">
              <div class="relatedSc">
                <a class="relatedItem merchandise" v-for="(item, i) in related"
                  :key="`prd${i}`" :href="`/uncorupted/product/${item.code}`">
                  <div class="relatedImg" v-if="item.images.length > 0 && item.images[0].media"
                    :style="{'background-image': `url(${item.images[0].media.imageSm})`}">
                  </div>
                  <div class="relatedImg noImg" v-else></div>
                  <h4>{{item.name}}</h4>
                  <div class="priceCntRlt" v-if="item.discount">
                    <div class="priceDiscount">
                      Rp {{item.sellPrice.toLocaleString('id')}}
                    </div>
                    <div class="price">Rp {{item.discountedPrice.toLocaleString('id')}}</div>
                  </div>
                  <div class="priceCntRlt" v-else>
                    <div class="price">Rp {{item.sellPrice.toLocaleString('id')}}</div>
                  </div>
                  <button class="btn primary">Beli Sekarang</button>
                </a>
              </div>
            </div>
          </div>
          <div v-if="donations.length > 0">
            <h4>Donasi</h4>
            <div class="relatedCnt">
              <div class="relatedSc">
                <a class="relatedItem row3 donation" v-for="(item, i) in donations"
                  :key="i" :href="`/donasi/${item.code}`">
                  <div class="relatedImg" v-if="item.headerMedia"
                    :style="{'background-image': `url(${item.headerMedia.imageSm})`}"></div>
                  <div class="relatedImg noImg" v-else></div>
                  <h4>{{item.title}}</h4>
                  <p>{{item.description}}</p>
                  <button class="btn primary">Kirimkan Donasi</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddedToCart ref="addedToCart"/>
    <Snackbar ref="snackbar"/>
    <PromoDetail ref="promoDetail"/>
    <CalcDelivery ref="calcDelivery"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import McHeader from '@/components/McHeader.vue';
import AddedToCart from '@/components/AddedToCart.vue';
import Snackbar from '@/components/Snackbar.vue';
import PromoDetail from '@/components/PromoDetail.vue';
import CalcDelivery from '@/components/CalcDelivery.vue';

export default {
  name: 'home',
  components: {
    Header,
    McHeader,
    AddedToCart,
    Snackbar,
    PromoDetail,
    CalcDelivery,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      size: 's',
      color: 'black',
      d: null,
      imgIdx: 0,
      tabActive: 0,
      bcTitle: 'Produk UNCORRUPTED / ...',
      promo: [],
      ddOpen: false,
      loadingCourier: true,
      couriers: [],
      address: null,
      cm: null,
      related: [],
      donations: [],
      prdTop: 0,
      images: [],
      shareUri: '',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
      this.ddOpen = false;
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
      const aHRect = this.$refs.endProduct.getBoundingClientRect();
      if (aHRect.top > 640) this.prdTop = window.pageYOffset;
    },
    calcDelivery() {
      this.$refs.calcDelivery.open({
        address: this.address,
        product: this.d,
        couriers: this.couriers,
      });
    },
    addToCart() {
      if (!this.$session.get('shb_icw_logged_in')) {
        this.$refs.mcHeader.openAccount();
        return;
      }

      if (this.d.variants.length > 0) {
        // eslint-disable-next-line
        for (const v of this.d.variants) {
          if (v.variants.length > 0 && v.selected === null) {
            v.error = true;
            return;
          }
        }
      }
      this.$refs.addedToCart.open(1, this.d, (b) => {
        if (!b) return;
        this.$refs.mcHeader.openCart();
      });
    },
    addToWishlist() {
      if (!this.$session.get('shb_icw_logged_in')) {
        this.$refs.mcHeader.openAccount();
        return;
      }
      if (this.d.inWishlist) {
        this.d.inWishlist = false; // eslint-disable-line
        this.$http.post(this.$config.uri('user/wishlist/remove'), {
          productId: this.d.id,
        }).then((r) => {
          this.$refs.mcHeader.countWishlist();
          this.$refs.snackbar.open({
            content: `${this.d.name} dihapus dari daftar favorit`,
          });
        });
        return;
      }
      this.d.inWishlist = true; // eslint-disable-line
      this.$http.post(this.$config.uri('user/wishlist'), {
        productId: this.d.id,
      }).then((r) => {
        this.$refs.mcHeader.countWishlist();
        this.$refs.snackbar.open({
          content: `${this.d.name} ditambahkan ke daftar favorit`,
        });
      });
    },
    selectVariant(i2, v2, i, v) {
      if (Number(v2.inStock.model) < 1) return;
      v.selected = i2; // eslint-disable-line
      v.error = null; // eslint-disable-line
      let variantHasImg = false;
      // eslint-disable-next-line
      for (const item of v.variants) {
        if (item.images && item.images.length > 0) {
          variantHasImg = true;
          break;
        }
      }
      if (variantHasImg) {
        this.imgIdx = 0;
        this.images = (v2.images && v2.images.length > 0) ? v2.images : this.d.images;
      }
    },
    getPromo() {
      this.$http.get(this.$config.uri('product/promo/all?active=y')).then((r) => {
        this.promo = (r.data.status === 200) ? r.data.data : [];
      });
    },
    getCourier() {
      this.$http.get(this.$config.uri('user/address?main=y')).then((r) => {
        if (r.data.status !== 200) return;
        this.address = r.data.data;
        this.$http.post(this.$config.uri('misc/courier/available'), {
          addressId: r.data.data.id,
          productId: this.d.id,
        }).then((r2) => {
          this.loadingCourier = false;
          this.couriers = (r2.data.status === 200) ? r2.data.data : [];
        });
      });
    },
    snk(item) { this.$refs.promoDetail.open(item); },
  },

  created() {
    window.addEventListener('scroll', this.docScrolled);
    document.getElementsByTagName('BODY')[0].classList.add('productDetail');
  },
  destroyed() {
    window.removeEventListener('scroll', this.docScrolled);
    document.getElementsByTagName('BODY')[0].classList.remove('productDetail');
  },
  mounted() {
    const { code } = this.$route.params;
    this.$http.get(this.$config.uri(`product/detail/${code}`)).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) {
        // Display not found
        return;
      }
      this.d = r.data.data;
      this.shareUri = `${this.$config.appUri}uncorupted/product/${this.d.code}`;
      this.images = this.d.images;
      this.bcTitle = `Produk UNCORRUPTED / ${this.d.name}`;
      this.getPromo();
      this.getCourier();

      this.$http.get(this.$config.uri(`product/all?related=${this.d.id}&limit=4`)).then((rPrd) => {
        this.related = (rPrd.data.status === 200) ? rPrd.data.data : [];
      });
      this.$http.get(this.$config.uri('donation/all?limit=3')).then((rDnt) => {
        this.donations = (rDnt.data.status === 200) ? rDnt.data.data : [];
      });
    });

    this.$http.get(this.$config.uri('misc/config/merchandise')).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) {
        // Display error
        return;
      }
      this.cm = r.data.data;
    });
  },
};
</script>

<style lang="scss">
.tabContent{
  .articleContent{
    padding: 20px 0;
    box-sizing: border-box;
    max-width: 760px;
    font-size: 16px;
    @media (max-width: 1100px) {
      max-width: calc(100% - 340px);
    }
    @media (max-width: 960px) {
      max-width: calc(100% - 300px);
    }
    @media (max-width: 820px) {
      max-width: none;
    }
    span{
      font-size: inherit !important;
    }
    p{
      margin: 0;
      line-height: 1.3;
      font-size: inherit !important;
    }
    ul{
      margin: 10px 0;
      padding-left: 24px;
      li{
        padding: 4px 0;
      }
    }
    .theMedia{
      max-width: 100%;
      margin: 0 0 20px;
      border-radius: 5px;
    }
  }
}
</style>

<style scoped lang="scss">
.notFound{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  h4{
    margin: 0;
  }
}
.priceCnt{
  font-weight: 500;
  padding: 10px 0 16px;
  @media (max-width: 820px) {
    display: none;
    padding: 0;
  }
  &.priceMobile{
    display: none;
    @media (max-width: 820px) {
      display: block;
    }
  }
  .priceDiscount{
    color: red;
    font-size: 13px;
    text-decoration: line-through;
    @media (max-width: 820px) {
      margin-bottom: 4px;
    }
  }
  .price{
    font-weight: 800;
    font-size: 24px;
  }
}
.addToCartBtnMobile{
  display: none;
  position: fixed;
  left: 0; right: 0; bottom: 0;
  background-color: #fff;
  border-top: #eee 1px solid;
  z-index: 991;
  padding: 10px 20px;
  align-items: center;
  box-shadow: 0 0 6px rgba(0, 0, 0, .1);
  @media (max-width: 820px) {
    display: flex;
  }
  .priceCnt{
    display: block;
    .price{
      font-size: 18px;
    }
    .priceDiscount{
      margin: 0;
      font-size: 12px;
    }
  }
  .outOfStock{
    border-radius: 50px;
    padding: 12px 30px;
    background-color: #ddd;
    color: #767676;
    margin-left: auto;
  }
  .btn{
    border-radius: 50px;
    padding-left: 54px;
    padding-right: 30px;
    position: relative;
    margin-left: auto;
    &:before{
      content: "";
      position: absolute;
      left: 16px; top: 6px;
      width: 34px; height: 34px;
      background-image: url(../assets/add-to-cart-white.png);
      background-size: 32px auto;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
    }
    &.wishlist{
      color: #444;
      font-size: 14px;
      &:before{
        background-image: url(../assets/heart.png);
        background-size: 18px;
        top: 3px;
      }
      &.loved{
        &:before{
          background-image: url(../assets/heart-loved.png);
          opacity: 1;
          animation: loved .3s ease;
        }
      }
    }
  }
}
.productCnt{
  display: flex;
  padding: 160px 0 40px;
  position: relative;
  @media (max-width: 820px) {
    display: block;
    padding: 105px 0 10px;
  }
  .productInfoImg{
    display: flex;
    width: calc(100% - 300px);
    @media (max-width: 1480px) {
      width: calc(100% - 240px);
    }
    @media (max-width: 1100px) {
      display: block;
      width: calc(100% - 340px);
    }
    @media (max-width: 960px) {
      width: calc(100% - 300px);
    }
    @media (max-width: 820px) {
      width: auto;
    }
    .productImgCnt{
      display: flex;
      position: relative;
      @media (max-width: 820px) {
        display: block;
      }
      .imgThumb{
        padding-right: 20px;
        .thumbItem{
          width: 80px; height: 80px;
          background-color: #eee;
          border-radius: 3px;
          margin-bottom: 10px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          cursor: pointer;
        }
        @media (max-width: 820px) {
          position: absolute;
          right: -10px; bottom: 10px;
          margin: 0; padding: 0;
          display: flex;
          .thumbItem{
            margin-bottom: 0;
            margin-left: 5px;
            width: 38px; height: 38px;
            border: #fff 2px solid;
          }
        }
      }
      .mainImg{
        width: 360px; height: 360px;
        background-color: #eee;
        border-radius: 5px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        &.noImg{
          background-image: url(../assets/image-black.png);
          background-size: 46px auto;
          border-color: #ccc;
          opacity: .34;
        }
        @media (max-width: 1480px) {
          width: 300px; height: 300px;
        }
        @media (max-width: 1100px) {
          width: calc(100% - 130px);
          height: calc(100vw - 530px);
          max-height: 400px;
        }
        @media (max-width: 820px) {
          width: auto;
          height: 320px;
          max-height: none;
          border-radius: 0;
          margin: 0 -20px;
        }
      }
    }
    .productInfo{
      width: calc(100% - 460px);
      box-sizing: border-box;
      padding: 0 30px;
      @media (max-width: 1480px) {
        width: calc(100% - 400px);
      }
      @media (max-width: 1100px) {
        width: auto;
        padding: 40px 0 0;
      }
      @media (max-width: 820px) {
        padding: 20px 0 0;
      }
      h2{
        margin: 0 0 20px;
        font-size: 32px;
        @media (max-width: 820px) {
          font-size: 22px;
          font-weight: normal;
          margin: 4px 0 10px;
        }
      }
      .infoTable{
        border: none;
        border-top: #ccc 1px dashed;
        border-bottom: #ccc 1px dashed;
        padding: 14px 0;
        width: 100%;
        tr td{
          vertical-align: top;
          padding: 2px 0;
        }
        .infoItem{
          font-size: 15px;
          .infoL{
            color: #767676;
            padding-right: 10px;
          }
          .infoR{
          }
        }
      }
      .deliveryInfo{
        padding: 20px 0 0;
        h4{
          margin: 0 0 10px;
          text-transform: uppercase;
          color: #888;
          font-weight: 800;
          font-size: 12px;
        }
        .warehouse{
          font-size: 15px;
        }
        .courierItem{
          font-size: 15px;
          position: relative;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .courierLogo{
            width: 30px; height: 20px;
            background-color: #fff;
            margin-right: 10px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            &.jne{
              background-image: url(../assets/courier/courier-jne.png);
            }
            &.pos{
              background-image: url(../assets/courier/courier-pos.png);
            }
            &.tiki{
              background-image: url(../assets/courier/courier-tiki.png);
            }
          }
          &.more{
            color: #035fae;
            font-weight: 600;
            margin-top: 10px;
            font-size: 14px;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{ color: #002f5f; }
          }
        }
        &.promoInfo{
          border-top: #ccc 1px dashed;
          margin-top: 20px;
          .promoCnt{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 0 -5px;
            @media (max-width: 1200px) {
              display: block;
            }
            .promoItem{
              position: relative;
              width: calc(50% - 10px);
              padding: 12px 26px;
              background-color: #eee;
              background-color: #fff8c0;
              box-sizing: border-box;
              margin-bottom: 10px;
              // color: #fff;
              overflow: hidden;
              @media (max-width: 1200px) {
                width: auto;
              }
              &:after{
                content: "";
                right: -60px; top: 50%;
                position: absolute;
                width: 160px; height: 160px;
                margin-top: -80px;
                background-color: #fef08d;
                border-radius: 50%;
              }
              &:before{
                content: "";
                position: absolute;
                left: -5px; top: 0; right: -5px; bottom: 0;
                border-left: #fff 10px dotted;
                border-right: #fff 10px dotted;
                z-index: 3;
              }
              .promoItemIn{
                position: relative;
                z-index: 3;
                h5{
                  margin: 0;
                  font-weight: normal;
                  font-size: 14px;
                  color: #776201;
                  font-weight: 500;
                }
                p{
                  margin: 2px 0;
                  font-weight: 800;
                  font-size: 16px;
                  color: #776200;
                }
                .info{
                  font-size: 10px;
                  font-weight: 500;
                  color: #000;
                  opacity: .6;
                }
                .snk{
                  cursor: pointer;
                  text-decoration: underline;
                  font-size: 13px;
                  margin-top: 4px;
                }
                .noQuota{
                  font-size: 13px;
                  margin-top: 5px;
                  background-color: #ccc;
                  color: #767676;
                  display: inline-block;
                  padding: 3px 8px;
                }
              }
            }
          }
          .promoInfoApplied{
            font-size: 12px;
            color: #767676;
            margin-top: 8px;
          }
        }
        &.loading{
          .courierItem{
            align-items: flex-start;
            .courierLogo{
              border-radius: 3px;
              background-color: #eee;
            }
            .courierInfo{
              height: 10px;
              background-color: #eee;
              border-radius: 3px;
              width: 120px;
              margin-top: 2px;
            }
            &.c2{
              .courierInfo{
                width: 100px;
              }
            }
            &.c3{
              .courierInfo{
                width: 80px;
              }
            }
          }
        }
      }
    }
  }
  .addToCartCnt{
    width: 300px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
    position: absolute;
    right: 0; top: 140px;
    padding: 20px 24px;
    box-sizing: border-box;
    z-index: 3;
    background-color: #fff;
    @media (max-width: 1480px) {
      width: 240px;
    }
    @media (max-width: 1100px) {
      width: 340px;
    }
    @media (max-width: 960px) {
      width: 300px;
    }
    @media (max-width: 820px) {
      width: auto;
      position: static;
      display: none;
      box-shadow: none;
      padding: 0 0 20px;
    }
    &.addToCartCntMobile{
      display: none;
      @media (max-width: 820px) {
        display: block;
      }
    }
    .variantCnt{
      margin-top: -16px;
      .variantError{
        background-color: red;
        font-size: 12px;
        border: red 1px solid;
        padding: 4px 10px;
        border-radius: 3px;
        margin: -2px 0 10px;
        color: #fff;
      }
    }
    h4{
      margin: 16px 0 6px;
      text-transform: uppercase;
      color: #888;
      font-weight: 800;
      font-size: 12px;
    }
    .variantSelector{
      display: flex;
      flex-wrap: wrap;
      .variantItem{
        border: #ccc 1px solid;
        min-width: 34px; height: 30px;
        text-align: center;
        padding: 5px 10px 0;
        margin: 0 6px 10px 0;
        box-sizing: border-box;
        border-radius: 3px;
        font-size: 14px;
        cursor: pointer;
        &.outOfStock{
          background-color: #d5d5d5;
          color: #767676;
          cursor: default;
          .color{
            opacity: .36;
          }
        }
        &.active{
          border-color: #035fae;
          box-shadow: 0 0 0 1px #035fae;
          background-color: #f0f8ff;
        }
        &.color{
          padding-left: 30px;
          position: relative;
          .color{
            width: 20px; height: 20px;
            border-radius: 3px;
            position: absolute;
            left: 4px; top: 4px;
            box-shadow: 0 0 2px rgba(0, 0, 0, .2);
          }
        }
      }
    }
    .inStock{
      margin-bottom: 4px;
    }
    .outOfStock{
      background-color: #eee;
      color: #767676;
      padding: 10px 20px;
      border-radius: 3px;
      margin-bottom: 2px;
    }
    .btn{
      width: 100%;
      font-size: 16px;
      padding: 10px 0;
      border-radius: 3px;
      text-align: left;
      padding-left: 48px;
      margin-bottom: 2px;
      font-weight: 400;
      position: relative;
      &:before{
        content: "";
        position: absolute;
        left: 10px; top: 3px;
        width: 30px; height: 30px;
        background-image: url(../assets/add-to-cart-white.png);
        background-size: 28px auto;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50%;
      }
      &.wishlist{
        color: #444;
        font-size: 14px;
        &:before{
          background-image: url(../assets/heart.png);
          background-size: 18px;
          top: 3px;
        }
        &.loved{
          &:before{
            background-image: url(../assets/heart-loved.png);
            opacity: 1;
            animation: loved .3s ease;
          }
        }
      }
    }
    .reminder{
      color: #035fae;
      font-weight: 600;
      margin-top: 10px;
      font-size: 13px;
      text-align: left;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{ color: #002f5f; }
    }
    .shareCnt{
      display: flex;
      align-items: center;
      font-size: 11px;
      padding-top: 14px;
      span{
        margin-right: 10px;
        font-weight: 500;
        color: #767676;
      }
      .shareItem{
        width: 26px; height: 26px;
        background-color: #035fae;
        border-radius: 50%;
        margin-right: 2px;
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        &.fb{
          background-image: url(../assets/i-facebook.png);
        }
        &.tw{
          background-image: url(../assets/i-twitter.png);
        }
        &.wa{
          background-image: url(../assets/i-whatsapp.png);
        }
        &.email{
          background-image: url(../assets/i-envelope.png);
        }
      }
    }
  }
}
.tabDdCnt{
  position: relative;
  padding: 0 20px;
  .tabDd{
    display: none;
    padding: 10px 20px;
    height: 44px;
    box-sizing: border-box;
    border-radius: 3px;
    margin-top: 16px;
    border: #eee 1px solid;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
    position: relative;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5fe;
    }
    &:before{
      content: "";
      position: absolute;
      right: 10px; top: 0; bottom: 0;
      width: 20px;
      background-image: url(../assets/arrow-down-dd.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .65;
    }
    @media (max-width: 680px) {
      display: block;
    }
  }
  .tabHeader{
    border-bottom: #eee 1px solid;
     @media (max-width: 680px) {
        position: absolute;
        left: 20px; right: 20px; top: 100%;
        display: block;
        border: none;
        background-color: #fff;
        z-index: 9;
        border-radius: 5px;
        padding: 12px 0;
        margin: 0;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
        display: none;
      }
    .cnt{
      display: flex;
      @media (max-width: 680px) {
        display: block;
        margin: 0;
      }
      li{
        list-style: none;
        padding: 10px 20px 8px;
        border-bottom: transparent 2px solid;
        transition: all .3s ease;
        margin-bottom: -1px;
        cursor: pointer;
        color: #767676;
        font-weight: 600;
        font-size: 15px;
        @media (max-width: 680px) {
          padding: 10px 20px;
          border: none;
        }
        &:hover{
          border-color: #ccc;
          color: #444;
        }
        &.active{
          border-color: #035fae;
          color: #035fae;
        }
      }
    }
  }
  &.open{
    .tabHeader{
      @media (max-width: 680px) {
        display: block;
      }
    }
  }
}
</style>
